import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Biller from './Biller';

const stepBackUrl = pathname => (pathname
  .split('/')
  .slice(0, -1)
  .join('/')
);

class BillerWithBack extends Component {
  static propTypes = {
    location: PropTypes.instanceOf(Object).isRequired,
  }

  render() {
    const { location } = this.props;
    const { pathname } = location;
    return (
      <React.Fragment>
        <Biller returnUrl={stepBackUrl(pathname)} />
      </React.Fragment>
    );
  }
}

export default withRouter(BillerWithBack);
